<template>
  <div class="common-nav-container">
    <div class="title-container">
      <p class="title-box">
        <svg-icon v-if="showBack" name="back" class="back" @click.native="$emit('back')" />
        <span class="title">{{ title }}</span>
      </p>
      <p v-if="help" class="help" :class="{ 'is-padding': showBack }">{{ help }}</p>
    </div>
    <slot name="tabLeft"></slot>
    <div v-if="tabList.length" class="tab-container">
      <span
        v-for="tab in tabList"
        :key="tab.label"
        :class="{ 'is-active': tabActive === tab.value }"
        class="tab-item"
        @click="handleTabChange(tab)"
      >
        {{ tab.value }}
      </span>
    </div>
    <slot name="tabRight"></slot>
    <app-link v-if="link.title" :to="link.to" class="link" :class="linkClass">{{ link.title }}</app-link>
  </div>
</template>
<script>
import AppLink from '@/layout/components/link'
export default {
  name: 'commonNav',
  components: { AppLink },
  props: {
    title: {
      type: String,
      require: true
    },
    help: {
      title: String,
      default: ''
    },
    showBack: {
      type: Boolean,
      default: false
    },
    /**
     * tabList
     * eg: [
     *  { label: '', value: '' }
     * ]
     */
    tabList: {
      type: Array,
      default: () => []
    },
    // 当前活跃的tab，值为tabList中对应的value
    tabActive: {
      type: String,
      default: ''
    },
    link: {
      type: Object,
      default: () => ({
        title: '',
        to: ''
      })
    },
    linkClass: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleTabChange(tab) {
      this.$emit('tabChage', tab)
    }
  }
}
</script>
<style lang="scss" scoped>
.common-nav-container {
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  .title-container {
    flex-shrink: 0;
    .title-box {
      display: flex;
      align-items: center;
      .back {
        margin-right: 6px;
        font-size: 24px;
        color: #4066d4;
        cursor: pointer;
      }
      .title {
        font-weight: 600;
        font-size: 24px;
        color: #000;
      }
    }
    .help {
      margin-top: 4px;
      font-weight: 600;
      font-size: 12px;
      line-height: 1.83;
      color: #000;
      &.is-padding {
        padding-left: 30px;
      }
    }
  }
  .tab-container {
    margin: 0 10px;
    flex: 1;
    align-self: stretch;
    display: flex;
    .tab-item {
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 14px;
      color: #7f8596;
      cursor: pointer;
      &.is-active {
        position: relative;
        color: #4066d4;
        &::after {
          position: absolute;
          content: '';
          bottom: -20px;
          left: -10px;
          right: -10px;
          height: 3px;
          background-color: #4066d4;
        }
      }
      &:nth-of-type(1) ~ .tab-item {
        margin-left: 42px;
      }
    }
  }
  .link {
    flex-shrink: 0;
    text-decoration: none;
    font-weight: 500;
    font-size: 14px;
    color: #4066d4;
  }
}
</style>
